import { jsx as _jsx } from "react/jsx-runtime";
import styles from './HomePage.module.scss';
import { createNewDate, getDatefromDate } from "../../utils/utils";
const GetDateMessage = ({ date }) => {
    return (_jsx("div", { className: styles.hr__container, children: _jsx("span", { className: styles.hr__element, children: getDatefromDate(createNewDate(date)) }) }));
};
export default GetDateMessage;
